import React from 'react';
import PropTypes from 'prop-types';
import MatchCard from '../MatchCard';
import {
  CARD_WIDTH,
  CARD_HEIGHT,
  ROW_HEIGHT,
  ROW_GAP,
  getMatchY,
} from '../../bracketLayout';
import classNames from 'classnames';
import styles from './BracketRound.module.scss';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import { getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import { useSelector } from 'react-redux';

const FINAL_LABELS = [
  'eventodeportivo_tablaposiciones_vistatorneo_texto_titulo1',
  'eventodeportivo_tablaposiciones_vistatorneo_texto_titulo2',
];

const BracketRound = ({ round, roundIndex }) => {
  const translations = useSelector(state => state.translations);
  // Detect Final by id (not by index) since the effective index changes
  // depending on which tab is active.
  const isFinalRound = round.id === 'final';

  const getY = matchIndex => {
    if (isFinalRound) {
      // Calculate the pitch between semifinals
      const factor = Math.pow(2, roundIndex - 1);
      const pitch = factor * ROW_HEIGHT;
      
      // Center Final and 3° lugar between the two semifinals
      const baseY = getMatchY(roundIndex, 0) - pitch / 2;
      
      return matchIndex === 0 ? baseY : baseY + pitch;
    }
    return getMatchY(roundIndex, matchIndex);
  };

  const lastIndex = round.matches.length - 1;
  const totalHeight = getY(lastIndex) + CARD_HEIGHT;

  return (
    <div
      className={classNames(styles['bracket-round'], styles[`bracket-round--${round.id}`])}
      style={{ width: CARD_WIDTH, height: totalHeight }}
      data-round-id={round.id}
    >
      {round.matches.map((match, i) => {
        const top = getY(i);
        const label = isFinalRound ? FINAL_LABELS[i] : null;

        return (
          <div
            key={match.id}
            className={styles['bracket-round__slot']}
            style={{ top, height: CARD_HEIGHT }}
          >
            {label && i === 0 && (
              <span className={`${styles['bracket-round__label']} ${styles['bracket-round__label--top']}`}>
                {renderMaxLengthText(
                  getTranslationEmptyOrNullKey(label, translations),
                  26,
                )}
              </span>
            )}

            <MatchCard
              homeTeam={match.homeTeam}
              awayTeam={match.awayTeam}
              date={match.date}
              time={match.time}
              timezone={match.timezone}
              status={match.status}
              isBroadcastAvailable={match.isBroadcastAvailable}
              progress={match.progress}
              id={match.id}
            />

            {label && i === 1 && (
              <span className={`${styles['bracket-round__label']} ${styles['bracket-round__label--bottom']}`}>
                {renderMaxLengthText(
                  getTranslationEmptyOrNullKey(label, translations),
                  26,
                )}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

BracketRound.propTypes = {
  round: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    matches: PropTypes.array.isRequired,
  }).isRequired,
  roundIndex: PropTypes.number.isRequired,
};

export default BracketRound;
